import { Card, CardContent, Typography, styled, Box, List, ListItem, ListItemText } from '@mui/material';

const AuthorCard = styled(Card)(({ theme }) => ({
  background: theme.palette.background.paper,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

interface TopAuthorsWidgetProps {
  authors: {
    username: string;
    videos: number;
  }[];
}

export const TopAuthorsWidget = ({ authors }: TopAuthorsWidgetProps) => {
  return (
    <AuthorCard>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
          Топ авторов
        </Typography>
        <List>
          {authors.map((author, index) => (
            <ListItem key={author.username} divider={index < authors.length - 1}>
              <ListItemText
                primary={`${index + 1}. ${author.username}`}
                secondary={`${author.videos} видео`}
                primaryTypographyProps={{ fontWeight: 'medium' }}
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </AuthorCard>
  );
};